module.exports = __webpack_public_path__ + "img/tultepec.cfd1dd04.jpg";